import { useForm, FormProvider } from "react-hook-form";
import { Field, FieldGroup } from "@/core/types/types";
import FormLayer from "./FormLayer/FormLayer";
import { componentsManager, scrollToErrorField } from "@/core/utils";
import { useEffect, useRef } from "react";

type FormProps = {
  formComponents: Field[];
  onSubmit: any;
};

const Form = ({ formComponents, onSubmit }: FormProps) => {
  const formRef = useRef<HTMLFormElement>(null);
  const formMethods = useForm();
  const {
    handleSubmit,
    formState: { errors },
  } = formMethods;
  const fieldItems: (Field | FieldGroup)[] = formComponents.reduce(
    componentsManager,
    []
  );
  const errorElements: string[] = Object.keys(errors);

  // Scroll to invalid form field
  if (errorElements.length) {
    scrollToErrorField(formRef, errorElements);
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <FormProvider {...formMethods}>
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <FormLayer fields={fieldItems} />
      </form>
    </FormProvider>
  );
};

export default Form;
